import { Injectable, inject } from '@angular/core';

import { WidgetType } from '@frontend/sports/types/components/widget';
import { WidgetRegistryService } from '@frontend/sports/widget/core/feature';
import { OnFeatureInit } from '@frontend/vanilla/core';

import { BannerWidgetComponent } from './banner-widget.component';

@Injectable({ providedIn: 'root' })
export class WidgetRegistrationService implements OnFeatureInit {
    private registry = inject(WidgetRegistryService);

    onFeatureInit(): void {
        this.registry.registerLazy(WidgetType.Banner, BannerWidgetComponent);
    }
}
